import { getStorage, uploadBytes, getDownloadURL, ref } from "firebase/storage"
import { getAuth } from "firebase/auth"
import getFirebase from "../../firebase"

const isDev = process.env.NODE_ENV === "development"
const SERVER_BASE_URL = isDev
  ? "https://api.dev.tulu.io"
  : "https://api.tulu.io"

async function requestPresignedPut({ bucket, folder, filename, contentType }) {
  const token = await getAuth(getFirebase()).currentUser.getIdToken()
  const res = await fetch(`${SERVER_BASE_URL}/uploads/presignPut`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      token,
      source: "tulu_website",
    },
    body: JSON.stringify({ bucket, folder, filename, contentType }),
  })
  if (!res.ok) {
    const errBody = await res.text()
    throw new Error(`presignPut failed (${res.status}): ${errBody}`)
  }
  return res.json()
}

function putToS3({ uploadUrl, file, contentType, onProgress }) {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest()
    xhr.open("PUT", uploadUrl, true)
    xhr.setRequestHeader("Content-Type", contentType)
    xhr.setRequestHeader("x-amz-acl", "public-read")
    xhr.upload.onprogress = evt => {
      if (evt.lengthComputable && onProgress) {
        onProgress(Math.round((evt.loaded / evt.total) * 100))
      }
    }
    xhr.onload = () => {
      if (xhr.status >= 200 && xhr.status < 300) {
        resolve()
      } else {
        reject(new Error(`S3 PUT failed: ${xhr.status} ${xhr.statusText}`))
      }
    }
    xhr.onerror = () => reject(new Error("S3 PUT network error"))
    xhr.send(file)
  })
}

const uploadFile = async (file, selectedBucket, onSuccess, onProgress) => {
  try {
    const contentType = file.type || "application/octet-stream"
    const { uploadUrl, publicUrl } = await requestPresignedPut({
      bucket: "tulu-assets",
      folder: selectedBucket,
      filename: file.name,
      contentType,
    })
    await putToS3({ uploadUrl, file, contentType, onProgress })
    onSuccess(publicUrl)
  } catch (err) {
    console.error("uploadFile error", err)
  }
}

export const singleFileUploadHandler = (
  selectedFile,
  selectedBucket,
  onSuccess,
  onProgress
) => {
  uploadFile(selectedFile, selectedBucket, onSuccess, onProgress)
}

export const uploadFiles = async (file, title, type) => {
  const storage = getStorage()
  const storageRef = ref(storage, "images/" + title + "_" + type + ".pdf")
  const metadata = {
    contentType: file.type,
  }

  const snapshot = await uploadBytes(storageRef, file, metadata)

  const url = await getDownloadURL(snapshot.ref)
  console.log(url)
  return url
}
